import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

function _callSuper2(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }

  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}

import { Component } from 'react';
import { connect } from 'react-redux';
import QueryParamProxy from '../../utils/queryParamProxy';
import Screens from '..';
import { REWARD_CENTER_ONBOARDING_STEPS } from '../../components/OnboardingLayer/onboardingSteps';
import { ONBOARDING_FLOWS } from '../../utils/onboarding';
import { setOnboardingStep as _setOnboardingStep } from '../../state/actions/currentOnboarding';
import { markOnboardingSeen as _markOnboardingSeen } from '../../state/actions/ftue';

var RewardCenterOnboarding = /*#__PURE__*/function (_Component) {
  function RewardCenterOnboarding() {
    var _this2;

    _classCallCheck(this, RewardCenterOnboarding);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this2 = _callSuper2(this, RewardCenterOnboarding, [].concat(args));

    _this2._clickHandler = function () {
      var _this2$props = _this2.props,
          markOnboardingSeen = _this2$props.markOnboardingSeen,
          setOnboardingStep = _this2$props.setOnboardingStep,
          navigation = _this2$props.navigation,
          dismissModal = _this2$props.dismissModal;
      dismissModal();
      setOnboardingStep(REWARD_CENTER_ONBOARDING_STEPS.SECOND_VISIT);
      markOnboardingSeen(ONBOARDING_FLOWS.REWARD_CENTER);
      QueryParamProxy.navigate(navigation, Screens.RewardCenter);
    };

    return _this2;
  }

  _inherits(RewardCenterOnboarding, _Component);

  return _createClass(RewardCenterOnboarding, [{
    key: "render",
    value: function render() {
      var _this$props$rewardCen, _this$props, _this$props$rewardCen2;

      return this.props.render({
        clickHandler: this._clickHandler,
        rewardCenterOnboardingAsset: (_this$props$rewardCen = (_this$props = this.props) === null || _this$props === void 0 ? void 0 : (_this$props$rewardCen2 = _this$props.rewardCenterAssets) === null || _this$props$rewardCen2 === void 0 ? void 0 : _this$props$rewardCen2.REWARD_CENTER_ONBOARDING) !== null && _this$props$rewardCen !== void 0 ? _this$props$rewardCen : null
      });
    }
  }]);
}(Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    isAccountLinked: state.playerInfo.isAccountLinked,
    rewardCenterAssets: state.assetsPackage.assets.REWARD_CENTER_FEATURE
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setOnboardingStep: function setOnboardingStep(step) {
      dispatch(_setOnboardingStep(step));
    },
    markOnboardingSeen: function markOnboardingSeen(onboardingFlow) {
      dispatch(_markOnboardingSeen(onboardingFlow));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RewardCenterOnboarding);